import { client } from '../http';

export default {
  async createAccessCodeUrl(idNumber, credentialsName) {
    const response = await client.post('/api/create-access-code', { idNumber, credentialsName });
    return response.data.url;
  },

  async getJointAccountRedirectUrl(requestId) {
    const response = await client.get(`/api/get-joint-account-redirect-url/${requestId}`);
    return response;
  },

  async convertAccessCodeToToken(accessCode, state) {
    const url = encodeURI(`/api/no-auth/convert-access-code/${encodeURIComponent(accessCode)}/${state}`);
    const response = await client.get(url);
    return response.data;
  },

  async getConnectionState(credentialsId) {
    const response = await client.get(`/api/connection-state/${credentialsId}`);
    return response.data;
  },
};
